import { HttpHandler, HttpRequest, HttpInterceptor } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';

import { AuthService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { Router } from '@angular/router';
import { PATH } from '@app/constants';

let ex: MatDialogRef<any, any>;

@Injectable({
   providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

   constructor(
      private modal: ModalService,
      private auth: AuthService,
      private toastr: ToastrService,
      private router: Router
   ) { }

   intercept(req: HttpRequest<any>, next: HttpHandler) {
      return next.handle(req).pipe(
         catchError((response) => {
            if (response.status !== 200) {
               switch (response.error?.err) {
                  // TOKEN INVALIDO
                  case 'RC02':
                     if (!ex) {
                        ex = this.modal.modalCustom({
                           img: 'https://static.monific.com/assets/assets-app/img/icon/img/pass_changed.svg',
                           title: 'Tu sesión se ha cerrado por inactividad.',
                           message: 'Por seguridad tu sesión se cierra automáticamente si no registra actividad.',
                           buttonText: 'Enterado'
                        });
                        ex.afterClosed().subscribe(() => { this.auth.cleanSession(); ex = undefined });
                     }
                     break;
                  // MOSTRAR TOAST CON INFO DE ERROR
                  case 'TS01':
                     this.toastr.warning(response.error.msg || '', 'Error');
                     break;
                  // MOSTRAR TOAST CON INFO DE AVISO
                  case 'RS01': {
                     const a = this.toastr.warning(response.error.msg || '', 'Aviso');
                  }
                     break;
                  case 'RD03':
                     this.toastr.warning(response.error.msg || 'Restablece tu contraseña');
                     this.router.navigate([PATH.ROUTE_FORGOT_PASS]);
                     break;
                  case 'RV02': {
                     const e = this.modal.modalCustom({
                        img: 'https://static.monific.com/assets/assets-app/img/icon/img/attention.svg',
                        title: 'RFC sin validar',
                        message: 'Es necesario verificar tu RFC antes de poder realizar esta acción. Por favor actualiza tu información.',
                        buttonText: 'Continuar'
                     });
                     e.beforeClosed().subscribe(() => this.router.navigate([PATH.ROUTE_PROFILE_CONFIG]))
                     break;
                  }
                  case 'UN03': {
                     // this.auth.cleanSession();
                     // this.router.navigate([PATH.ROUTE_REGISTRY])

                     const currentUrl = this.router.url;
                     localStorage.setItem('lastUrl', currentUrl);
                     this.auth.cleanSession();
                     this.router.navigate([PATH.ROUTE_AUTH_LOGIN]);
                     break;

                     // const s = this.modal.modalCustom({
                     //    img: 'https://static.monific.com/assets/assets-app/img/icon/img/login.svg',
                     //    title: 'Inicia sesión o crea tu cuenta ahora.',
                     //    message: 'Ir a https://app.monific.com/',
                     //    buttonText: 'Continuar'
                     // });
                     // s.beforeClosed().subscribe(() => this.auth.cleanSession());
                     // break;
                  }
               }
            }

            return throwError(response);
         })
      );
   }
}
